import { useEffect } from 'react'
import { BOOKING_STEP } from 'components/BookingModal/constants'

export const usePreselectAvailableTime = ({
  availabilities,
  bookingStep,
  firstAvailability,
  setDisplayedDate,
  setSelectedDate,
  userAuth,
  isBookingModalOpen,
}) => {
  useEffect(() => {
    if (bookingStep === BOOKING_STEP.DATETIME_PICKER && firstAvailability) {
      const firstDisplayedDate = userAuth?.user
        ? userAuth.convertDateToTimezone(firstAvailability.startAtUtc.isoFormat)
        : new Date(firstAvailability.startAtUtc.isoFormat)
      const firstAvailabilityStartAtDate = new Date(
        firstAvailability.startAtUtc.isoFormat
      )
      setSelectedDate(firstAvailabilityStartAtDate)
      setDisplayedDate(firstDisplayedDate)
    }
  }, [
    bookingStep,
    firstAvailability,
    setDisplayedDate,
    setSelectedDate,
    userAuth,
    isBookingModalOpen,
  ])

  useEffect(() => {
    if (
      bookingStep === BOOKING_STEP.DATETIME_PICKER &&
      availabilities.length !== 0
    ) {
      const firstAvailabilityStartAtDate = new Date(
        availabilities[0].startAtUtc.isoFormat
      )
      setSelectedDate(firstAvailabilityStartAtDate)
    }
  }, [availabilities, bookingStep, setSelectedDate, isBookingModalOpen])
}
